import _ from 'lodash';
import qs from 'qs';
import axios from 'axios';
import sendEventsMixin from '@mixins/sendEventsMixin';
import FilterComponent from './filterComponent';

export default {
  components: {FilterComponent},
  props: {
    category_id: {
      type: Number,
    },
  },
  mixins: [sendEventsMixin],
  computed: {
    queryPage() {
      return this.$route.query.page || null;
    },
    searchQuery: function() {
      return this.$route.query && this.$route.query.s;
    },
    categoryTitle: function() {
      let title = this.category.inheritance_name;

      if (!title) {
        title = this.category.meta_title;
      }

      return title || 'Catalog';
    },
    paginationLinks: function() {
      if (!this.total_pages) {
        return [];
      }

      let links = [];

      if (this.page > 1) {
        links.push({
          rel: 'prev',
          name: 'Previous Page',
          href: this.$route.path + '?page=' + (this.page - 1),
        });
      }

      if (this.page < this.total_pages) {
        links.push({
          rel: 'next',
          name: 'Next Page',
          href: this.$route.path + '?page=' + (this.page + 1),
        });
      }

      return links;
    },
    productsQuery: function() {
      return {
        categories: this.categories,
        page: this.page,
        catalog_id: this.catalog_id,
      };
    },
    productApiUrl: function() {
      return '/api/v1/products';
    },
    catalogDescription: function() {
      return null;
    },
  },
  data: () => ({
    loading: true,
    catalogLoaded: false,
    order_by: 'default',
    categories: [],
    category: {},
    products: [],
    selectedFilters: [],
    availableFilters: [],
    whitelistFilters: [],
    pagination: [],
    page: 1,
    total_pages: 1,
    sortPresets: {
      default: {},
      price_low: {
        field: 'price',
        desc: 0,
      },
      price_high: {
        field: 'price',
      },
      top_sellers: {
        field: 'sells',
      },
      newest: {
        field: 'created_at',
      },
      best_seller: {
        field: 'bought_count',
      },
    },
    cancelRequest: null,
    productsLoading: true,
    updatingFiltersFromQuery: false,
  }),
  mounted() {
    this.loadCatalog();
  },
  watch: {
    order_by: function() {
      this.page = 1;
      this.updateProducts();
    },
  },
  methods: {
    loadCatalog: function() {
      let params = {};

      if (this.category_id) {
        params.category_id = this.category_id;
      }

      if (this.searchQuery) {
        params.search = this.searchQuery;
      }

      axios.get(`/api/v1/catalog`, {
        params: params,
        paramsSerializer: function(params) {
          return qs.stringify(params, {arrayFormat: 'indices'});
        },
      }).then((r) => {
        this.categories = r.data.categories || [];
        this.category = r.data.data || {};
        this.whitelistFilters = this.flatFilterObject(r.data.filters);
        this.availableFilters = this.flatFilterObject(r.data.filters);
        this.page = this.$route.query.page ? this.$route.query.page : 1;

        this.updatingFiltersFromQuery = true;
        this.updateProducts();

        if (r.data.pagination) {
          this.page = r.data.pagination.current_page;
          this.total_pages = r.data.pagination.total_pages;
        }

        this.onCategoryLoaded(this.categoryTitle);
      }).then(() => {
        this.loading = false;
      });
    },
    loadProductVariant: function(product, optionId, optionValue) {
      this.updateProductSelectedOptions(product, optionId, optionValue);

      const params = _.map(product.selected_options,
        (value, key) => ({id: key, value_id: value}));
      axios.get(`/api/v1/products/${product.id}/variants`, {
        params: {options: params},
        paramsSerializer: function(params) {
          return qs.stringify(params, {arrayFormat: 'indices'});
        },
      }).then(response => {
        if (!_.isEmpty(response.data)) {
          product.defaultVariant.data = response.data.data[0];
          if (product.defaultVariant.data.images.length) {
            product.image = '';
          }
        }
      }).catch(error => {

      });
    },
    nextPage: function(unfocus = false) {
      if (this.productsLoading || this.loading) {
        return;
      }

      const cList = this.$refs['catalogList'];

      if (unfocus && cList) {
        const lastItem = cList.querySelector('.last-child');
        lastItem && lastItem.focus();
      }

      if (this.total_pages !== 1 && this.total_pages !== this.page) {
        window.onscroll = () => {
        };
        this.page++;
        this.updateProducts();
      }
    },
    initInfiniteLoad: function() {
      window.onscroll = () => {
        const scrollTrigger = document.documentElement.scrollTop +
          window.innerHeight >= (this.$refs.catalog_container.offsetHeight -
            (this.$refs.catalog_container.offsetHeight / 4));

        if (scrollTrigger && this.page <= 3) {
          this.nextPage();
        }
      };
    },
    getProductUrl: function(product) {
      if (!product.defaultVariant.data.id) {
        return product.permalink;
      }

      return product.defaultVariant.data.permalink;
    },
    updateProducts: function() {
      const self = this,
        CancelToken = axios.CancelToken;
      if (typeof this.cancelRequest === 'function') {
        this.cancelRequest();
      }

      const params = this.getProductRequestFilters();

      this.productsLoading = true;

      const requestOptions = {
        params: params,
        paramsSerializer: function(params) {
          return qs.stringify(params, {arrayFormat: 'indices'});
        },
        cancelToken: new CancelToken(function executor(c) {
          self.cancelRequest = c;
        }),
      };

      axios.get(this.productApiUrl, requestOptions).then((response) => {
        this.updateView(response.data);
        return this.updateFilters();
      }).then((response) => {
        this.whitelistFilters = this.flatFilterObject(response.data);
      }).then(() => {
        this.productsLoading = false;
        this.initInfiniteLoad();
        this.catalogLoaded = true;
      }).catch((error) => {
        this.productsLoading = true;
        console.error(error);
      });
    },
    updateFilters: function() {
      let params = this.getProductRequestFilters();
      params['category_id'] = this.category_id;

      const requestParams = {
        params: params,
        paramsSerializer: function(params) {
          return qs.stringify(params, {arrayFormat: 'indices'});
        },
      };

      return axios.get('/api/v1/products/filters', requestParams);
    },
    getProductRequestFilters: function() {
      const params = Object.assign({}, this.productsQuery,
        this.filterArrayToPostObj(this.selectedFilters));

      if ('default' !== this.order_by) {
        params['order_by'] = this.sortPresets[this.order_by];
      }

      if (this.searchQuery) {
        params['search'] = this.searchQuery;
      }

      if (this.category_id) {
        params['primary_category_id'] = this.category_id;
      }

      return params;
    },
    updateView: function(responseData) {
      if (1 === this.page) {
        this.products = responseData.data;
      } else {
        this.products.push(...responseData.data);
      }
      this.page = responseData.meta.pagination.current_page;
      this.total_pages = responseData.meta.pagination.total_pages;
      this.pagination = responseData.meta.pagination;
      this.sendImpressions();
    },
    onFilterChange(payload) {
      this.selectedFilters = payload;
      this.updateProducts();
    },
    getProductImage: function(index) {
      const product = this.products[index];
      const images = product.defaultVariant.data.images.data;

      let image = product.image || '';

      if (images.length) {
        image = images[0].url;
      }

      return `url(${image})`;
    },
    getSecondProductImage: function(index) {
      const product = this.products[index];
      const defaultVariantHasImages = product.defaultVariant?.data?.images?.data?.length > 0
      const images = defaultVariantHasImages
        ? product.defaultVariant?.data?.images?.data
        : product?.images?.data

      if (images?.length && images[1]) {
        return `url(${images[1].url})`;
      }

      return this.getProductImage(index)
    },
    isHasDiscount: function(product) {
      return !!product.is_has_discount;
    },
    isNew: function(product) {
      return product.show_new_badge;
    },
    hasDisplayOptions: function(product) {
      return this.getDisplayOptions(product).length > 0;
    },
    isOptionDisplayed: function(product, optionId, optionValueId) {
      const options = _.get(product, 'defaultVariant.data.values.data');
      const passedOption = options.filter(
        item => item.option.id === optionId && item.option.value_id ===
          optionValueId);

      return !_.isEmpty(passedOption);
    },
    hasVariants: function(product, optionId, optionValueId) {
        const options = _.get(product, 'options.data');
        const optionValueWithVariants = options.filter((option) => {
            const values = option.values.filter(value => value.id === optionValueId);

            return option.id === optionId && values.shift()?.variants_quantity > 0;
        });

        return !_.isEmpty(optionValueWithVariants);
    },
    getDisplayOptions: function(product) {
      return _.filter(product.options.data, item => item.is_displayable);
    },
    updateProductSelectedOptions: function(product, optionId, optionValue) {
      let selectedOptions = product.selected_options || {};
      selectedOptions[optionId] = optionValue;
      product.selected_options = selectedOptions;
    },
    sendImpressions() {
      try {
        this.products.forEach((product, index) => {
          let object = {
            'id': product.sku || product.id,
            'name': product.title,
            'category': this.category.inheritance_name,
            'brand': product.vendor_name,
            'list': 'Catalog Page',
            'position': index + 1,
          };

          window.ga('ec:addImpression', object);
        });

        window.ga('ec:setAction', 'detail');
        window.ga('send', 'pageview');
      } catch (e) {
        console.error('unable send tracking data');
      }
    },
    /**
     * Transform { filter_groups: {data: [name: 'Origin'], values: [{id: 1, name: 'Imported' }, {id: 2, name: 'Not'}]} }
     * into
     * [{groupName: 'filter_groups', name: 'Origin', values: [{id: 1, name: 'Imported}, {id: 2, name: 'Not'}]}]
     * @param receivedData
     * @returns {unknown[]}
     */
    flatFilterObject(receivedData) {
      const forEachObjInAr = (ar, f) => ar.map(obj => f(obj));

      return Object.keys(receivedData).
        map(groupName => ({...receivedData[groupName], groupName})).
        map(e =>
          forEachObjInAr(e.data,
            o => ({...o, groupName: e.groupName}),
          ),
        ).
        flat();
    },
    /**
     *
     * Transform array with objects
     * `[{ groupName: 'options', id: 1, value: 11 },
     *   { groupName: 'options', id: 1, value: 23 },
     *   { groupName: 'filter', id: 20, value: 54},
     *  ]`
     * into object
     * `{
     *    options: [{id: 1, values: [11, 23]}],
     *    filter: [{id: 20, values: [54]}]
     *  }`
     * @param selectedFiltersArray {Array<{groupName: String, id: Number, value: Number}>}
     * @returns { [key: String]: Array<{id: Number, values: Array<Number>}>}
     */
    filterArrayToPostObj(selectedFiltersArray) {
      const valuesForID = (groupName, filterId) => selectedFiltersArray.filter(
        e => e.groupName === groupName).
        filter(e => e.id === filterId).
        map(e => e.value).
        flat();
      const groups = selectedFiltersArray.map(e => e.groupName);
      const generateInnerArray = (
        groupName, arrayOfSelectedFilters) => arrayOfSelectedFilters.filter(
        e => e.groupName === groupName).
        reduce((acc, p) => [
          ...acc,
          {id: p.id, values: valuesForID(p.groupName, p.id)}], []);

      return groups.map(
        g => ({[g]: generateInnerArray(g, selectedFiltersArray)})).
        reduce((acc, p) => ({...acc, ...p}), {});
    },
  },
};
